import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import configService from '../services/configService';

function CountryAvailabilityModal({ 
  isOpen, 
  onClose, 
  countryCode, 
  email 
}) {
  const { logout } = useAuth();
  const [loading, setLoading] = useState(false);
  const [showThankYou, setShowThankYou] = useState(false);

  if (!isOpen) return null;

  const getCountryName = (code) => {
    const countries = {
      '+44': 'United Kingdom',
      '+33': 'France', 
      '+49': 'Germany',
      '+39': 'Italy',
      '+34': 'Spain',
      '+61': 'Australia',
      '+81': 'Japan'
    };
    return countries[code] || 'your country';
  };

  const handleNotifyMe = async () => {
    setLoading(true);
    
    try {
      await configService.joinInternationalWaitlist(
        email,
        countryCode,
        getCountryName(countryCode)
      );

      setShowThankYou(true);
      setTimeout(async () => {
        setShowThankYou(false);
        onClose();
        await logout();
      }, 3000);
      
    } catch (error) {
      console.error('Failed to join waitlist:', error);
      // Wait a moment to ensure error is logged before logout
      setTimeout(async () => {
        onClose();
        await logout();
      }, 500);
    } finally {
      setLoading(false);
    }
  };

  if (showThankYou) {
    return (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
        <div className="bg-white p-8 rounded-2xl max-w-md w-full mx-4 shadow-xl text-center">
          <h2 className="text-2xl font-bold text-blue-600 mb-4">Thank You!</h2>
          <p className="text-gray-600">
            We'll notify you as soon as Remote Assistant becomes available in {getCountryName(countryCode)}.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white p-8 rounded-2xl max-w-md w-full mx-4 shadow-xl">
        <h2 className="text-2xl font-bold text-gray-900 mb-4">Service Not Available Yet</h2>
        <p className="text-gray-600 mb-6">
          Remote Assistant is currently only available in the United States and Canada. 
          We're working hard to expand to {getCountryName(countryCode)} soon!
        </p>
        <p className="text-gray-600 mb-6">
          Would you like to be notified when we launch in your country?
        </p>
        
        <div className="flex gap-3">
          <button 
            className="flex-1 px-6 py-3 bg-blue-500 hover:bg-blue-600 text-white rounded-xl font-semibold transition-colors disabled:opacity-70 disabled:cursor-not-allowed"
            onClick={handleNotifyMe}
            disabled={loading}
          >
            {loading ? 'Joining...' : 'Yes, Notify Me'}
          </button>
          <button 
            className="flex-1 px-6 py-3 bg-white border border-gray-300 text-gray-700 hover:bg-gray-50 rounded-xl font-semibold transition-colors"
            onClick={() => {
              // Small delay to ensure any pending operations complete
              setTimeout(async () => {
                onClose();
                await logout();
              }, 100);
            }}
            disabled={loading}
          >
            No Thanks
          </button>
        </div>
      </div>
    </div>
  );
}

export default CountryAvailabilityModal;